import { Box } from '@mui/material';
import React, { useContext } from 'react';

import { RTLDirectionContext } from '../../../../Layout';
import { imageHeight } from '../utils/analysis';

interface SideCameraOverlayProps {
    horizontalPixel?: number;
    side: 'left' | 'right';
}

export const SideCameraOverlay: React.FC<SideCameraOverlayProps> = (props: SideCameraOverlayProps) => {
    const isRTL = useContext(RTLDirectionContext);
    let isLeft = props.side === 'left';
    if (isRTL) {
        isLeft = !isLeft;
    }

    return (
        <>
            <Box
                sx={{
                    height: '100%',
                    width: '0px',
                    border: '1px solid white',
                    position: 'absolute',
                    boxShadow: '0px 0px 5px 1px #000, inset 0px 0px 5px 1px #000',
                    top: 0,
                    left: isLeft ? '10%' : '90%',
                }}
            />
            {props.horizontalPixel !== undefined ? (
                <Box
                    sx={{
                        width: '100%',
                        height: '0px',
                        border: '1px solid white',
                        position: 'absolute',
                        top: `${(Math.max(props.horizontalPixel, 0) / imageHeight) * 100}%`,
                        boxShadow: '0px 0px 5px 1px #000, inset 0px 0px 5px 1px #000',
                    }}
                />
            ) : null}
        </>
    );
};

export default SideCameraOverlay;
